import { render, staticRenderFns } from "./RejectionList.vue?vue&type=template&id=03f25723&scoped=true&"
import script from "./RejectionList.vue?vue&type=script&lang=js&"
export * from "./RejectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f25723",
  null
  
)

export default component.exports